var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSmoking = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 41"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h40v41H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M21.967 20.43c-1.45.494-2.718 1.128-3.773 1.128-1.576 0-3.39-1.147-6.054-1.703-2.94-.615-5.372-.807-5.372-.807s1.945 4.89 6.868 6.796c1.183.459 3.282-.054 4.56-.054 1.402 0 3.241.49 4.384.068a10.9 10.9 0 0 0 3.02-1.72M28.07 21.505c.967-1.357 1.394-2.457 1.394-2.457s-1.409.2-3.324.51M29.014 17.95s-2.516-1.128-5.41-1.486c-1.834-.227-3.819.256-5.413.256-1.616 0-3.657-.478-5.538-.247-2.907.356-5.435 1.476-5.435 1.476s3.046-5.915 5.688-5.915 5.285 1.063 5.285 1.063 2.641-1.063 5.283-1.063 5.54 5.915 5.54 5.915ZM32.785 26.321l-5.635-5.743M24.644 23.13l5.5 5.607M32.785 26.32s-.904-.328-1.878.535c-.973.862-.936 1.736-.679 1.998.256.26.955.79 2.21-.3 1.152-1.001.665-1.814.347-2.232Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "m18.191 16.72 6.453 6.411s-.172-1.11.59-1.885c.763-.777 1.915-.668 1.915-.668l-4.479-4.173"
}))));
export default SvgSmoking;